import axios from "axios";
import {API_VERSION} from "@constants/API";
import {API_HOST} from "@constants/ENV";

const clearSession = () => {
    localStorage.clear();
    window.dispatchEvent(new Event('storage'));
    window.location.href = '/login';
};

const isRefreshTokenExpired = (error) => {
    const code = String(error.response?.data?.error || '').toLowerCase().replace(/[_-]/g, '');
    return code === 'refreshtokenexpired';
};

const hasAuthorizationHeader = (headers = {}) =>
    Boolean(headers.Authorization || headers.authorization || (typeof headers.get === 'function' && headers.get('Authorization')));

const setAuthorizationHeader = (headers, value) => {
    if (typeof headers.set === 'function') {
        headers.set('Authorization', value);
    } else {
        headers.Authorization = value;
    }
};

export default function refreshToken(failedRequest) {
    const refreshTokenValue = localStorage.getItem('refreshToken');

    return axios({
        method: 'post',
        url: `https://${API_HOST}/${API_VERSION}/RefreshAccessToken`,
        data: new URLSearchParams({refreshToken: refreshTokenValue})
    })
        .then(res => res.data)
        .then(response => {
            localStorage.setItem("accessToken", response.accessToken);

            if (hasAuthorizationHeader(failedRequest.config.headers)) {
                setAuthorizationHeader(failedRequest.config.headers, `Bearer ${response.accessToken}`);
            } else {
                const params = new URLSearchParams(failedRequest.config.data || {});
                const paramsObject = {};
                params.forEach((value, key) => {
                    paramsObject[key] = value;
                });
                paramsObject.accessToken = response.accessToken;
                failedRequest.config.data = new URLSearchParams(paramsObject);
            }

            return Promise.resolve();
        })
        .catch(error => {
            if (isRefreshTokenExpired(error)) clearSession();
            return Promise.reject(error);
        });
}
